import React from 'react';
import { compose } from 'redux';
import CertonaZoneIris from '../../../components/CertonaZoneIris/CertonaZoneIris';
import withReducerSaga from '../../../hoc/ReducerRegistry/withReducerSaga';
import ProductCartridgeReducer from '../../../reducers/ProductCartridgeReducer';
import watchProductListForRecommendation from '../../../sagas/ProductCartridgeSaga';

const CertonaZoneIrisWrapper = ({
    strategy,
    style,
    pageType,
    deviceType,
    backgroundColor,
    isAdobe = false,
    departmentid,
}) => {
    const slotDetails = {
        pageType,
        deviceType,
        slotId: strategy,
        automationId: 'product-cartridge',
        loader: 'certona',
        attributes: {
            contentrecommendations: false,
            recommendations: true,
            departmentid,
        },
        style,
        backgroundColor,
    };
    return (
        <CertonaZoneIris
            page={`${slotDetails.pageType}-${slotDetails.slotId}`}
            slotDetails={slotDetails}
            disableLazyLoad={!deviceType.isDesktop}
            schemasToRender={slotDetails.slotId}
            isAdobe={isAdobe}
        />
    );
};

export default compose(
    withReducerSaga([ProductCartridgeReducer], [watchProductListForRecommendation])
)(CertonaZoneIrisWrapper);
